import SelectCandidateRowContainer from './select_candidate_row_container';

const SelectCandidateRow = SelectCandidateRowContainer;
export default SelectCandidateRow;
